<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="row != null">
      <v-card-text class="pa-6">
        <v-text-field v-model="row.name" label="Nome" />
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        showDelete
        @delete="$refs.dialog.$apply('DELETE')"
        @cancel="$refs.dialog.$dismiss()"
        @apply="$refs.dialog.$apply(row)"
        txtApply="OK"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { VehicleOwner } from '@/models'

export default {
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default
  },
  data() {
    return {
      row: null
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      let row = await VehicleOwner.findById(this.id)
      this.row = row
    }
  }
}
</script>

<style></style>
